module.exports = __webpack_public_path__ + "img/cookies-illustration-white.4301f039.svg";